import React from 'react';
import { Button, DialogActions } from '@mui/material';
import { useTranslation } from 'hooks';

interface FilterDialogActionsProps {
  onApply: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}

const FilterDialogActions = ({ onApply, disabled }: FilterDialogActionsProps) => {
  const { t } = useTranslation();

  return (
    <DialogActions
      sx={{
        px: 2,
        py: '12px',
        pb: 'max(12px, env(safe-area-inset-bottom))',
        flexShrink: 0,
        bgcolor: 'common.white',
        boxShadow: '0 -2px 8px rgb(0 0 0 / 8%)',
        zIndex: 1,
      }}
    >
      <Button
        fullWidth
        variant="contained"
        disabled={disabled}
        onClick={onApply}
        sx={{
          minHeight: 48,
          color: 'text.primary',
          fontSize: 16,
          fontWeight: 700,
          borderRadius: '12px',
        }}
      >
        {t('apply')}
      </Button>
    </DialogActions>
  );
};

export default FilterDialogActions;
